
<router-outlet></router-outlet>
<message-box></message-box>